export default __webpack_public_path__ + "static/media/our-team-02.73c3395d.jpg";